export default __webpack_public_path__ + "static/media/image-icon.f50b8a76.svg";